import axios from 'axios';

import { ENV } from '@/services/config/env-config';

export const ApiClient = axios.create({
  withCredentials: true,
  baseURL: ENV.API_URL,
  timeout: ENV.REQUEST_API_TIMEOUT_DEFAULT,
  headers: {
    'Content-Type': 'application/json',
  },
});

/* Requests made with responseType 'blob' (file downloads) get their *error*
   bodies as a Blob too, so the JSON error envelope never reaches the error
   validator and every failure degrades to the generic fallback toast. Parse
   those back into objects here so per-code messages work on downloads as they
   do everywhere else. */
ApiClient.interceptors.response.use(undefined, async (error: unknown) => {
  if (
    axios.isAxiosError(error) &&
    error.response?.data instanceof Blob &&
    error.response.data.type.includes('json')
  ) {
    try {
      error.response.data = JSON.parse(await error.response.data.text());
    } catch {
      /* Not JSON after all — leave the Blob and let the caller handle it. */
    }
  }

  throw error;
});
